// Helpers shared by every customer-profile mock scenario, so each scenario
// file only has to describe the dates/numbers that make it distinct.

import {PLACEHOLDER_LOGO_URL} from "@/demo/placeholderLogo";

export const DAY_MS = 24 * 60 * 60 * 1000;
export const HOUR_MS = 60 * 60 * 1000;
export const iso = (offsetMs: number) => new Date(Date.now() + offsetMs).toISOString();

const DAY_IN_SECONDS = 24 * 60 * 60;

// Produces a token in the same header.payload.signature shape that
// isValidShareToken (CustomerProfile/ESimInstallation/ESimShopProfile) expects:
// it only ever reads the middle segment as base64-encoded {sub, exp} JSON.
export const makeShareToken = (iccid: string, validDays: number = 7) => {
    const payload = { sub: iccid, exp: Math.floor(Date.now() / 1000) + validDays * DAY_IN_SECONDS };
    return `mockheader.${btoa(JSON.stringify(payload))}.mocksignature`;
};

export const country = (code: string, name: string) => ({
    code,
    name,
    imageUrl: `/esim/countries/${code.toLowerCase()}/flag`
});

export const EUROPE_COUNTRIES = [
    country("AT", "Austria"), country("BE", "Belgium"), country("BG", "Bulgaria"),
    country("HR", "Croatia"), country("CY", "Cyprus"), country("CZ", "Czech Republic"),
    country("DK", "Denmark"), country("EE", "Estonia"), country("FI", "Finland"),
    country("FR", "France"), country("DE", "Germany"), country("GR", "Greece"),
    country("HU", "Hungary"), country("IS", "Iceland"), country("IE", "Ireland"),
    country("IT", "Italy"), country("LV", "Latvia"), country("LI", "Liechtenstein"),
    country("LT", "Lithuania"), country("LU", "Luxembourg"), country("MT", "Malta"),
    country("NL", "Netherlands"), country("NO", "Norway"), country("PL", "Poland"),
    country("PT", "Portugal"), country("RO", "Romania"), country("SK", "Slovakia"),
    country("SI", "Slovenia"), country("ES", "Spain"), country("SE", "Sweden"),
    country("CH", "Switzerland"), country("TR", "Turkey"), country("UA", "Ukraine"),
    country("AL", "Albania"), country("GB", "United Kingdom")
];

// The same customer/eSIM identity is reused across every scenario - only the
// dates and balances differ from one lifecycle stage to the next.
export const MOCK_ICCID = "89440123456789104832";
export const MOCK_DOMAIN_ID = "domain-europe-pack";
export const MOCK_ACTIVATION_CODE = "LPA:1$mock-smdp.example.com$MOCK-EUR-ACT-CODE-88214";

export const MOCK_RESELLER_INFORMATION = {
    name: "",
    logoUrl: PLACEHOLDER_LOGO_URL,
    // Read only by the pages still on StoreLayout, e.g. the Shopify profile.
    headerColor: "#1F2937",
    accentColor: "#0B7A73",
    faqUrl: "https://example.com/faq"
};
